import React from 'react'
import Input from 'Components/Input'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Select from 'Components/Select'
import { SketchPicker } from 'react-color'
import Utils from 'EurestoFonction/Utils'


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor(props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      saveState: { ...EurestoClone(newState) },
      ...newState
    }
  }

  componentDidMount() {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getProduit()
    }
  }

  getProduit = async () => {
    const result = await ApiRequest(project.api + 'restaurant', {
      requete: 'table_categorie',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle,
        actif: result.results.actif,
        libelle: result.results.libelle,
        forme: result.results.forme,
        couleur: result.results.couleur,
        regroupable: result.results.regroupable,
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      libelle: undefined,
      actif: 1,
      forme: undefined,
      couleur: undefined,
      regroupable: false,
      key: Utils.getRandomNumber(),
      action: 'add',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'restaurant', {
      requete: 'table_categorie',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      actif: 1,
      forme: this.state.forme,
      couleur: this.state.couleur,
      regroupable: this.state.regroupable || 0,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'restaurant', {
      requete: 'table_categorie',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
    newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  }

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  }

  form = (disabled, autoFocus) => {

    const popover = {
      position: 'absolute',
      zIndex: 10,
      right: 0,
    }
    const cover = {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    }
    const buttonColor = {
      width: '36px',
      height: '14px',
      borderRadius: '2px',
      background: this.state.couleur || '#0F9009',
    }

    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
        justify="flex-start"
        alignItems="stretch">
        <Input
          title={EurestoI18n.t('commun:Catégorie de table')}
          disabled={disabled}
          autoFocus={autoFocus}
          onChange={this.onChangeState}
          name={'libelle'}
          value={this.state.libelle !== undefined ? this.state.libelle : ''}
        />
        <Grid container spacing={8}>
          <Grid item xs>
            <Select
              title={EurestoI18n.t('crm:Forme')}
              name="forme"
              disabled={disabled}
              onChange={this.onChangeState}
              value={this.state.forme}
              options={[{
                value: 1,
                label: 'Rectangulaire'
              }, {
                value: 2,
                label: 'Ronde'
              }]} />
          </Grid>
          <Grid item style={{ position: 'relative' }}>

            <button disabled={disabled} style={buttonColor} onClick={this.handleClick} />
            {this.state.displayColorPicker && <div style={popover}>
              <div style={cover} onClick={this.handleClose} />
              <SketchPicker
                onChange={this.onChangeState}
                color={this.state.couleur || '#0F9009'}
                onChangeComplete={e => this.onChangeState(e.hex, 'couleur')}
              />
            </div>}
          </Grid>
        </Grid>
      </Grid>
    )
  }

  render() {
    return (
      <EurestoForm key={this.state.key}
        {...this.props.formProps}
        libelle={this.state.defaultLibelle}
        action={this.state.action}
        isAllow={this.props.isAllow}
        onSave={this.onSave}
        onCancel={this.onCancel}
        onDelete={this.onDelete}
        onArchive={this.onArchive}
        onView={this.onView}
        libelleAdd={EurestoI18n.t('commun:Nouvelle catégorie de table')}
        children={this.form} />
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Reservation/TableCategorie.js